import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_add_shipments"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = { class: "me-0" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_16 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_17 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_18 = { class: "menu-item px-3" }
const _hoisted_19 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_23 = { class: "menu-item px-3" }
const _hoisted_24 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_25 = { class: "menu-item px-3" }
const _hoisted_26 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_27 = { class: "menu-item px-3" }
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_29 = { class: "card-body pt-0" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "w-50px h-50px d-flex align-items-center justify-content-center p-2 bg-light-primary rounded-3 me-2" }
const _hoisted_32 = { class: "flex-fill d-flex-column justify-content-center" }
const _hoisted_33 = { class: "text-nowrap" }
const _hoisted_34 = { class: "text-nowrap" }
const _hoisted_35 = { class: "mb-1" }
const _hoisted_36 = { class: "fs-7 text-gray-400" }
const _hoisted_37 = { class: "mb-1" }
const _hoisted_38 = { class: "fs-7 text-gray-400" }
const _hoisted_39 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MBDatatable = _resolveComponent("MBDatatable")!
  const _component_addShipments = _resolveComponent("addShipments")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
              ]),
              _createTextVNode(_toDisplayString(_ctx.t("common.filter")), 1)
            ]),
            _createVNode(_component_FilterDropdown, {
              onSubmitFilter: _ctx.handleFilter,
              onResetFilter: _ctx.handleFilterReset
            }, null, 8, ["onSubmitFilter", "onResetFilter"]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.add")) + _toDisplayString(_ctx.t("common.shipments")), 1)
            ])), [
              [_directive_auth, { auth: ['add'] }]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn btn-icon btn-bg-light btn-active-color-primary",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end",
                disabled: 
                _ctx.disabledExportLogisticsDetailsReport ||
                _ctx.disabledExportOverseaShipmentReport ||
                _ctx.disabledExportOverseasShipmentTracking ||
                _ctx.disabledExportOutboardReport ||
                _ctx.loading
              
              }, [
                (
                  _ctx.disabledExportLogisticsDetailsReport ||
                  _ctx.disabledExportOverseaShipmentReport ||
                  _ctx.disabledExportOverseasShipmentTracking ||
                  _ctx.disabledExportOutboardReport
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                  : (_openBlock(), _createElementBlock("i", _hoisted_16))
              ], 8, _hoisted_14),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t("common.export")), 1)
                ]),
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                    disabled: _ctx.disabledExportOverseaShipmentReport || _ctx.loading,
                  }]),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fileExportOverseaShipmentReport && _ctx.fileExportOverseaShipmentReport(...args))),
                    style: {"font-size":"normal"}
                  }, [
                    (_ctx.disabledExportOverseaShipmentReport && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("shipments.exportOverseaShipmentReport")), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                    disabled: _ctx.disabledExportLogisticsDetailsReport || _ctx.loading,
                  }]),
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fileExportLogisticsDetailsReport && _ctx.fileExportLogisticsDetailsReport(...args))),
                    style: {"font-size":"normal"}
                  }, [
                    (_ctx.disabledExportLogisticsDetailsReport && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("shipments.exportLogisticsDetailsReport")), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                    disabled: _ctx.disabledExportOverseasShipmentTracking || _ctx.loading,
                  }]),
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fileExportOverseasShipmentTracking && _ctx.fileExportOverseasShipmentTracking(...args))),
                    style: {"font-size":"normal"}
                  }, [
                    (_ctx.disabledExportOverseasShipmentTracking && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("shipments.exportOverseasShipmentTrackingReport")), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                    disabled: _ctx.disabledExportOutboardReport || _ctx.loading,
                  }]),
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fileExportOutboardReport && _ctx.fileExportOutboardReport(...args))),
                    style: {"font-size":"normal"}
                  }, [
                    (_ctx.disabledExportOutboardReport && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("shipments.exportOutboardReport")), 1)
                  ], 2)
                ])
              ])
            ])), [
              [_directive_auth, { auth: ['export'] }]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_MBDatatable, {
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          selection: true,
          order: "desc",
          onSelectChange: _ctx.onRowsSelectChange,
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-tracking_no": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                (_ctx.getServiceProvider(item.service_provider))
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      class: "d-flex",
                      lazy: "",
                      fit: "contain",
                      title: item.__show.service_provider,
                      src: _ctx.getServiceProvider(item.service_provider)
                    }, null, 8, ["title", "src"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_router_link, {
                  to: 
                  '/transport-management/shipments/' +
                  item.id +
                  '/' +
                  item.shipment_id +
                  '/edit'
                ,
                  class: "text-gray-800 text-hover-primary d-block leading-none mb-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.tracking_no), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_component_router_link, {
                  to: 
                  '/transport-management/shipments/' +
                  item.id +
                  '/' +
                  item.shipment_id +
                  '/edit'
                ,
                  class: "fs-7 text-gray-400 text-hover-primary d-block leading-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.shipment_id), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]),
          "cell-actual_time_of_departure": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDate(item.actual_time_of_departure)), 1)
          ]),
          "cell-actual_time_of_arrival": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.formatDate(item.actual_time_of_arrival)), 1)
          ]),
          "cell-delivery_from": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_35, _toDisplayString(item.__show.delivery_from_country), 1),
            _createElementVNode("div", _hoisted_36, _toDisplayString(item.__show.delivery_from), 1)
          ]),
          "cell-destination": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_37, _toDisplayString(item.__show.destination_country), 1),
            _createElementVNode("div", _hoisted_38, _toDisplayString(item.__show.destination), 1)
          ]),
          "cell-status": _withCtx(({ row: item }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge text-uppercase", _ctx.getShipmentStatusMap(Number(item.status))])
            }, _toDisplayString(item.__show.status), 3)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            _createVNode(_component_router_link, {
              to: 
              '/transport-management/shipments/' +
              item.id +
              '/' +
              item.shipment_id +
              '/edit'
            ,
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_39, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onSelectChange", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_addShipments, { onUpdateList: _ctx.updateList }, null, 8, ["onUpdateList"])
  ], 64))
}